// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/store_invoice.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { StoreInvoiceStatus } from "../../enum/v1/store_invoice_status_pb.js";

/**
 * @generated from message fingertip.common.type.v1.StoreInvoice
 */
export const StoreInvoice = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreInvoice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "invoice_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(StoreInvoiceStatus) },
    { no: 5, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "billing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 11, name: "void_at", kind: "message", T: Timestamp },
    { no: 12, name: "due_at", kind: "message", T: Timestamp },
    { no: 13, name: "completed_at", kind: "message", T: Timestamp },
    { no: 14, name: "next_reminder_at", kind: "message", T: Timestamp },
    { no: 15, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "footer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "payment_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "price_includes_tax", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "pass_through_payment_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "total_application_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "application_fee", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 24, name: "total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "total_tax_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "items_total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "item_discounts_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "amount_remaining_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 30, name: "amount_paid_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 31, name: "minimum_charge_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "payment_fee_paid_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "payment_fee_remaining_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "application_fee_paid_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 35, name: "application_fee_remaining_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

